import { Injectable } from '@angular/core';
import { PermissionType } from '../enums/permission-type.enum';
import { User } from 'src/app/core/interfaces/user.interface';
import { AppInterface } from 'src/app/core/interfaces/app.interface';
import { CollectionDetailsDTO } from 'src/app/core/interfaces/collection.interface';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  checkPermission(user: User, permission: PermissionType): boolean {
    return user.permissions.includes(permission);
  }

  canUseAdminUI(user: User): boolean {
    return (
      this.checkPermission(user, PermissionType.UseAdminUI) &&
      this.checkPermission(user, PermissionType.CanModifyAllowedUrls)
    );
  }
  
  canEditApp(_user: User, _app: AppInterface): boolean {
    return this.checkPermission(_user, PermissionType.UseAdminUI) || this.isAppOwnerOrEditor(_user, _app);
  }
  
  canEditCollection(_user: User, _collection: CollectionDetailsDTO): boolean {
    return this.checkPermission(_user, PermissionType.UseAdminUI) || this.isCollectionOwnerOrEditor(_user, _collection);
  }
  
  isCollectionOwnerOrEditor(_user: User, _collection: CollectionDetailsDTO): boolean {
    return [_collection.owner, _collection.creator, ..._collection.editors]
            .some(ownerEditor => ownerEditor?.userPrincipalName?.toLowerCase() === _user.ntId.toLowerCase());
  }
  
  isAppOwnerOrEditor(_user: User, _app: AppInterface): boolean {
    return [_app.appCreator, ..._app.appEditors!]
            .some(ownerEditor => ownerEditor?.userPrincipalName?.toLowerCase() === _user.ntId.toLowerCase());
  }
}
